import {OptionValue, Category} from "../ValueObjects";

export interface OptionFilter<T> extends Filter {
	values:T[];

	autoCloseOnSelection():boolean;
}

export interface Filter {
	id:string;
	name:string;
}

export class KeywordFilter implements Filter {
	isExpanded:boolean = false;
	id:string = '';
	name:string = '';
}

export interface FieldFilterJson {
	id:string;
	name:string;
	values:OptionValueJson[]
}

export class FieldFilter implements OptionFilter<FieldOptionValue> {
	static fromObjects(objects:FieldFilterJson[]):FieldFilter[] {
		return objects.map((object) => new FieldFilter(object));
	}

	values:FieldOptionValue[];
	id:string;
	name:string;

	constructor(object:FieldFilterJson) {
		this.values = FieldOptionValue.fromObjects(object.values)
		this.id     = object.id
		this.name   = object.name
	}

	autoCloseOnSelection():boolean {
		return true;
	}
}

export class CategoryFilter implements OptionFilter<Category> {

	id   = "categoryFilter";
	name = "Category";

	constructor(public values:Category[]) {
	}

	autoCloseOnSelection():boolean {
		return false;
	}
}

export class ArchiveFilter implements OptionFilter<ArchivedStatus> {

	values:ArchivedStatus[] = [ArchivedStatus.CURRENT, ArchivedStatus.ALL]
	id:string = "archiveFilter"
	name:string = "Archive"

	/**
	 * Because we only allow selections (and not deselections) of options in this filter, it is a bit confusing to
	 * instantly close the filter after selecting, and very jarring to the eye. Thus, lets leave it open.
	 * @returns {boolean}
	 */
	autoCloseOnSelection():boolean {
		return false;
	}
}

export class ArchivedStatus implements OptionValue {

	private static current = new ArchivedStatus("current", "Current");
	private static all = new ArchivedStatus("all", "All");

	public static get CURRENT():ArchivedStatus { return ArchivedStatus.current; }

	public static get ALL():ArchivedStatus { return ArchivedStatus.all; }

	constructor(private id:string, private label:string) {}

	getId():string { return this.id;}

	getLabel():string { return this.label;}
}

interface OptionValueJson {
	id:string
	label:string
}

export interface FieldOptionValueJson extends OptionValueJson {}

export class FieldOptionValue implements OptionValue {
	id:string = '';
	label:string = '';

	getId():string { return this.id; };

	getLabel():string { return this.label; };

	static fromObjects(objects:FieldOptionValueJson[]):FieldOptionValue[] {
		return objects.map(function (object):FieldOptionValue {
			const value = new FieldOptionValue();
			value.id    = object.id;
			value.label = object.label;
			return value;
		});
	}
}

export class FilterSelectionState {

	private map:Map<Filter, Set<OptionValue>> = new Map<Filter, Set<OptionValue>>()

	clearSelected(filter:OptionFilter<OptionValue>) {
		this.getSelected(filter).forEach((value:OptionValue) => {
			this.setSelected(filter, value, false);
		})
	}

	// For now only supports selecting one item, but it wasn't clear in the original spec, so this should be relatively
	// trivial to support multiple selections (though the semantics of the server side querying will be less trivial)
	setSelected(filter:OptionFilter<OptionValue>, value:OptionValue, isSelected:boolean) {
		const valueSet = new Set<OptionValue>();
		if (isSelected) {
			valueSet.add(value)
		}
		this.map.set(filter, valueSet)
	}

	getSelected(filter:Filter):Set<OptionValue> {
		let set = this.map.get(filter)
		if (set === undefined) {
			set = new Set<OptionValue>()
			this.map.set(filter, set)
		}
		return set
	}

	serialize():StringMap<string[]> {
		var selected:StringMap<string[]> = {};
		for (const filter of this.map.keys()) {
			selected[filter.id] = this.serializeFilter(filter);
		}
		return selected;
	}

	serializeFilter(filter:Filter):string[] {
		return Array.from(this.getSelected(filter)).map(value => value.getId())
	}

}



// WEBPACK FOOTER //
// ./src/news2/advancedSearch/filter/ValueObjects.ts